/* tslint:disable */

/**
 */
export class DeviceForm {
    id?: number;
    device_model_id?: number;
    identity?: string;
    is_running?: number;
    version?: number;
    lat?: number;
    lng?: number;
}
